import { createTheme } from '@aws-amplify/ui-react'

export default createTheme({
  name: 'my-theme',
  tokens: {
    components: {
      button: {
        primary: {
          backgroundColor: {
            value: '#384fa2',
          },
          _hover: {
            backgroundColor: {
              value: 'rgb(56, 79, 162, 0.8)',
            },
          },
          _active: {
            backgroundColor: {
              value: '#4760b9',
            },
          },
        },
      },
      field: {
        fontSize: { value: '{fontSizes.sm}' },
      },
    },
  },
})
